// extracted by mini-css-extract-plugin
export default {"modal":"PhotoModal_modal__oCBuq","container":"PhotoModal_container__fMkqm","close":"PhotoModal_close__s3ZAv","image":"PhotoModal_image__s2ICb"};